const EntityStatus = {
    INACTIVE:  0,
    ACTIVATED: 1
}

const issuanceType = {
    VOUCHER: 1,
    COUPON: 2,
    PROMOTION: 3
}

const Evoucher_Img_Default = require('../assets/evoucher_img_default.svg')
export default {EntityStatus, Evoucher_Img_Default, issuanceType}